<div>
  <navaar-container-scroll
    [showHeader]="true"
    [title]="title"
    [show]="true"
    [isPlayAnimation]="false"
    [isFixedContainer]="true"
  >
    <navaar-list-items
      (go-to)="goToPage($event)"
      [disable-when-fetch-data]="isLoading"
      [isEnd]="isEnd"
      [items]="items"
      [more-icon]="false"
      [type]="'none'"
      [event-tracker-name]="'x_plp_list_items'"
    ></navaar-list-items>
  </navaar-container-scroll>
</div>
